import {RouteContext} from "../../RouteContext";
import {
    DetailPage,
    DetailPagePanelConstraint,
    DetailPagePanelIndicator,
    DetailPagePropertyIndicator
} from "../../common/DetailPage";
import {PlaceParticipationValueObject} from "../../../../model/vo/content/place/PlaceParticipationValueObject";
import {PlaceParticipationIO} from "../../../../io/content/place/PlaceParticipationIO";
import {Column} from "../../common/Layout";
import {ListPage} from "../../common/ListPage";
import {PlacePathJointValueObject} from "../../../../model/vo/content/place/PlacePathJointValueObject";
import {PlacePathJointIO} from "../../../../io/content/place/PlacePathJointIO";
import {Switch} from "@fluentui/react-components";
import React from "react";
import {useStatePair} from "../../../../type/States";

const propertyDetail: DetailPagePropertyIndicator<PlaceParticipationValueObject> = {}

type Panel = DetailPagePanelConstraint | 'placePathJointId';

const panelDescription: Record<Panel, string> = {
    Main: '기본',
    placePathJointId: '플레이스 경로 Joint'
};

export default function Detail(props: RouteContext) {
    const isActiveState = useStatePair<Map<bigint, boolean>>(new Map<bigint, boolean>())

    const setActive = (id: bigint, isActive: boolean) => {
        const acc = new Map<bigint, boolean>(isActiveState.value)
        acc.set(id, isActive)
        isActiveState.setValue(acc)
    }

    const panelDetail: DetailPagePanelIndicator<PlaceParticipationValueObject, Panel> = {
        placePathJointId: (props: RouteContext, item: PlaceParticipationValueObject): JSX.Element => <>
            <Column gap={'16px'}>
                <ListPage
                    {...props}
                    description={PlacePathJointValueObject.description}
                    list={PlacePathJointIO.list}
                    count={PlacePathJointIO.count}
                    postHref={'/admin/places/pathJoints/post'}
                    detailHref={item => `/admin/places/pathJoints/${item.id}`}
                    itemValue={(item, key) => {
                        if (key === 'isActive') {
                            const present = isActiveState.value.get(item.id)
                            if (present !== undefined) {
                                return <>
                                    <Switch
                                        checked={present}
                                        onChange={(ev, data) =>
                                        {

                                            const id = Number(item.id.toString().split('n')[0])


                                            fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/places/paths/joints/${id}`,
                                                {
                                                    method: 'PATCH',
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                    },
                                                    credentials: 'include',
                                                    body: JSON.stringify({
                                                        wishState: data.checked
                                                    }),
                                                }
                                            )
                                                .then(async value => {
                                                    const res = await value.json()
                                                    console.log(res)

                                                    if(!res){
                                                        return
                                                    }

                                                    setActive(item.id, data.checked)

                                                })
                                        }
                                        }

                                    />
                                </>
                            } else {
                                return <>
                                    <Switch
                                        checked={item.isActive}
                                        onChange={(ev, data) =>
                                        {
                                            const id = Number(item.id.toString().split('n')[0])

                                            fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/places/paths/joints/${id}`,
                                                {
                                                    method: 'PATCH',
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                    },
                                                    credentials: 'include',
                                                    body: JSON.stringify({
                                                        wishState: data.checked
                                                    }),
                                                }
                                            )
                                                .then(async value => {
                                                    const res = await value.json()
                                                    console.log(res)

                                                    if(!res){
                                                        return
                                                    }

                                                    setActive(item.id, data.checked)

                                                })
                                        }
                                        } />
                                </>
                            }
                        } else {
                            return undefined
                        }
                    }}
                    initialSearchConditions={[
                        {
                            name: 'id',
                            value: String(item.placePathJointId),
                            condition: 'Equal'
                        },
                    ]}
                />

            </Column>
        </>
    };

    return (
        <DetailPage
            {...props}
            propertyDescription={PlaceParticipationValueObject.description}
            propertyDetail={propertyDetail}
            panelDescription={panelDescription}
            panelDetail={panelDetail}
            get={PlaceParticipationIO.get}
        />
    );
}
